var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgInfoDex(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 14,
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_11700_177)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M7.0006 0.539062C8.71431 0.539062 10.3578 1.21983 11.5696 2.4316C12.7814 3.64338 13.4621 5.28689 13.4621 7.0006C13.4621 8.71431 12.7814 10.3578 11.5696 11.5696C10.3578 12.7814 8.71431 13.4621 7.0006 13.4621C5.28689 13.4621 3.64338 12.7814 2.4316 11.5696C1.21983 10.3578 0.539063 8.71431 0.539062 7.0006C0.539062 5.28689 1.21983 3.64338 2.4316 2.4316C3.64338 1.21983 5.28689 0.539063 7.0006 0.539062ZM7.96976 4.50616C8.44973 4.50616 8.83924 4.17296 8.83924 3.67915C8.83924 3.18533 8.44881 2.85213 7.96976 2.85213C7.4898 2.85213 7.10213 3.18533 7.10213 3.67915C7.10213 4.17296 7.4898 4.50616 7.96976 4.50616ZM8.13867 9.69995C8.13867 9.60118 8.17282 9.34459 8.15344 9.19875L7.39473 10.0719C7.23781 10.2371 7.04121 10.3516 6.94891 10.3211C6.90704 10.3057 6.87203 10.2759 6.8502 10.237C6.82838 10.198 6.82116 10.1526 6.82984 10.1088L8.09437 6.11405C8.19775 5.60732 7.91346 5.14489 7.31073 5.08581C6.67478 5.08581 5.73884 5.731 5.16935 6.54971C5.16935 6.64755 5.15089 6.89122 5.17027 7.03706L5.92806 6.16297C6.08497 5.9996 6.26773 5.88422 6.36003 5.9156C6.40551 5.93192 6.44277 5.96542 6.46382 6.00891C6.48488 6.0524 6.48804 6.10241 6.47264 6.1482L5.21919 10.1236C5.07428 10.5888 5.34841 11.0448 6.01298 11.1482C6.99137 11.1482 7.56918 10.5187 8.1396 9.69995H8.13867Z",
    fill: "#0098EA"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_11700_177"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 14,
    height: 14,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInfoDex);
export default __webpack_public_path__ + "static/media/info_dex.aa32eacb37d9fd1408a0087dd5abb759.svg";
export { ForwardRef as ReactComponent };